import { useQuery } from '@tanstack/react-query'

import type { MyBookingDetail } from '../../types/booking.js'

import { apiClient } from '../../lib/client.js'
import { bookingKeys } from './keys.js'

export const useGetMyBookingByRefQuery = (bookingRef: string | undefined) =>
  useQuery({
    enabled: !!bookingRef,
    queryFn: async () => {
      const response = await apiClient.client.get<MyBookingDetail>(`/me/bookings/${bookingRef}`)
      // Filet si l'API n'expose pas encore `trips` (front publié avant le backend).
      return { ...response.data, trips: response.data.trips ?? [] }
    },
    queryKey: bookingKeys.myBookingByRef(bookingRef ?? ''),
  })
